import { TooltipIcon } from '@ipfabric/ui-components/Tooltip/TooltipIcon';

import { FormikTextAreaField } from 'components/FormikTextAreaField/FormikTextAreaField';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';
import type { FormikValueAdapter } from 'utils/formik/FormikValueAdapter';

interface BaseUrlsValues {
  baseUrls: string[];
}

interface Props<T extends BaseUrlsValues> {
  formik: FormikProps<T>;
  placeholder?: string;
}

const stringInputToBaseUrl: FormikValueAdapter<
  string,
  BaseUrlsValues['baseUrls']
> = {
  toInput: (value) => value?.join('\n') ?? '',
  toModel: (value) => value.split(/\r?\n/).map((baseUrl) => baseUrl.trim()),
};

export const FormikVendorApiBaseUrlsField = <T extends BaseUrlsValues>(
  props: Props<T>,
): JSX.Element => {
  return (
    <FormikTextAreaField
      className='h-24'
      formik={props.formik}
      label={
        <>
          * Base URLs
          <TooltipIcon
            content='You can enter multiple base URLs, each on a new line.'
            iconProps={{
              iconStyle: 'solid',
              inline: true,
            }}
            className='ml-2'
            size='sm'
          />
        </>
      }
      name='baseUrls'
      transformValue={stringInputToBaseUrl}
    />
  );
};
